export const SlideTraversalConstant = {
    CHANGE_CASE : "CHANGE_CASE"
} 


